export const mapUnits = (item) => {
  item.values.map((val) => {
    val.complete = val.fact && val.plan ? `${(val.fact / val.plan * 100).toFixed(2)}%` : '-';
    //val.fact ? val.fact = val.fact.toFixed(3) : val.fact = '-'; //для этой обработки есть функция getFieldRenderFunction, нужна ли вообще теперь mapUnits?
    //val.plan ? val.plan = val.plan.toFixed(3) : val.plan = '-';
    //val.estimate ? val.estimate = val.estimate.toFixed(3) : val.estimate = '-';
  });
  return item;
};

export const groupBy = (list, keyGetter) => {
  const map = new Map();
  list?.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
};
